import {AdvertisementBannerSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/basket_sections.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {BasPromotionMonitoring, TrackBASMonitoring} from '@aboutyou/tracking';
import {tabletAndUp} from '@aboutyou/ui-components';
import {isCaseTypeCheck} from '@aboutyou/utils';
import React from 'react';
import styled, {css} from 'styled-components';
import {
  Advertisement,
  AdvertisementTracking,
} from '../../../features/Advertisement/Advertisement';

interface BasketBannerViewProps extends AdvertisementBannerSection {
  containBanner?: boolean;
  promotionSource?:
    | BasPromotionMonitoring['originalSource']
    | AdvertisementTracking['promotionSource'];
}

export const BasketBannerView: React.FC<BasketBannerViewProps> = ({
  type,
  containBanner: contained = false,
  promotionSource = TrackingPromotionCreative.BasBasketBanner,
}) => {
  if (!isCaseTypeCheck('ads', type) || !type.ads.advertisement.image) {
    return <TrackBASMonitoring basPromotionSource={promotionSource} />;
  }

  const {advertisement} = type.ads;

  return (
    <StyledAdvertisement
      advertisement={advertisement}
      contained={contained}
      testId="advertisementBasket"
      tracking={{
        promotionSource:
          promotionSource as AdvertisementTracking['promotionSource'],
        streamPosition: 0,
      }}
    />
  );
};

const StyledAdvertisement = styled(Advertisement)`
  position: relative;
  aspect-ratio: 3.9 / 1; // The BAS team usually sets 750x192 images
  overflow: hidden;

  ${tabletAndUp(css`
    margin-bottom: 14px;
    border-radius: 5px;
    aspect-ratio: 5.6 / 1;
  `)}
`;
